/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M17 2V14M17 14C15.3431 14 13.5 15.7909 13.5 18C13.5 20.2091 15.3431 22 17 22C18.6569 22 20.5 20.2091 20.5 18C20.5 15.7909 18.6569 14 17 14Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M7 2V11M7 22V11M7 11L5.42496 9.94997C4.90398 9.60265 4.64349 9.42899 4.45491 9.19955C4.28796 8.99643 4.1627 8.76238 4.0863 8.5108C4 8.22663 4 7.91355 4 7.28741V2M7 11L8.57504 9.94997C9.09602 9.60265 9.35651 9.42899 9.54509 9.19955C9.71204 8.99643 9.8373 8.76238 9.9137 8.5108C10 8.22663 10 7.91355 10 7.28741V2"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M20.5 18C20.5 20.2091 18.6569 22 17 22C15.3431 22 13.5 20.2091 13.5 18C13.5 15.7909 15.3431 14 17 14C18.6569 14 20.5 15.7909 20.5 18Z"
				fill="currentColor"
			/>
			<path
				d="M7 2V11M7 22V11M7 11L5.42496 9.94997C4.90398 9.60265 4.64349 9.42899 4.45491 9.19955C4.28796 8.99643 4.1627 8.76238 4.0863 8.5108C4 8.22663 4 7.91355 4 7.28741V2M7 11L8.57504 9.94997C9.09602 9.60265 9.35651 9.42899 9.54509 9.19955C9.71204 8.99643 9.8373 8.76238 9.9137 8.5108C10 8.22663 10 7.91355 10 7.28741V2M17 2V14M17 14C15.3431 14 13.5 15.7909 13.5 18C13.5 20.2091 15.3431 22 17 22C18.6569 22 20.5 20.2091 20.5 18C20.5 15.7909 18.6569 14 17 14Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4.75009 2C4.75009 1.58579 4.4143 1.25 4.00009 1.25C3.58588 1.25 3.25009 1.58579 3.25009 2V7.28741L3.25004 7.38118C3.24965 7.91548 3.24935 8.33556 3.36875 8.72874C3.47381 9.07466 3.64604 9.39648 3.87559 9.67577C4.1365 9.99322 4.48619 10.226 4.93097 10.522L5.00902 10.574L6.25009 11.4014V22C6.25009 22.4142 6.58588 22.75 7.00009 22.75C7.4143 22.75 7.75009 22.4142 7.75009 22V11.4014L8.99116 10.574L9.06921 10.522C9.51399 10.226 9.86368 9.99322 10.1246 9.67577C10.3541 9.39648 10.5264 9.07466 10.6314 8.72874C10.7508 8.33556 10.7505 7.91549 10.7501 7.38119V7.38118L10.7501 7.28741V2C10.7501 1.58579 10.4143 1.25 10.0001 1.25C9.58588 1.25 9.25009 1.58579 9.25009 2V7.28741C9.25009 7.96025 9.24245 8.14041 9.19615 8.29286C9.1484 8.4501 9.07011 8.59638 8.96577 8.72333C8.8646 8.84642 8.71894 8.95271 8.1591 9.32594L7.75009 9.59861V2C7.75009 1.58579 7.4143 1.25 7.00009 1.25C6.58588 1.25 6.25009 1.58579 6.25009 2V9.59861L5.84107 9.32594C5.28124 8.95271 5.13557 8.84642 5.03441 8.72333C4.93007 8.59638 4.85178 8.4501 4.80403 8.29286C4.75773 8.14041 4.75009 7.96025 4.75009 7.28741V2ZM17.7501 2C17.7501 1.58579 17.4143 1.25 17.0001 1.25C16.5859 1.25 16.2501 1.58579 16.2501 2V13.3392C15.4339 13.5317 14.6697 14.0212 14.0776 14.663C13.2975 15.5084 12.7501 16.6851 12.7501 18C12.7501 19.3149 13.2975 20.4916 14.0776 21.337C14.8484 22.1725 15.9109 22.75 17.0001 22.75C18.0892 22.75 19.1518 22.1725 19.9226 21.337C20.7027 20.4916 21.2501 19.3149 21.2501 18C21.2501 16.6851 20.7027 15.5084 19.9226 14.663C19.3305 14.0212 18.5663 13.5317 17.7501 13.3392V2Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M7 2V11M7 22V11M7 11L5.42496 9.94997C4.90398 9.60265 4.64349 9.42899 4.45491 9.19955C4.28796 8.99643 4.1627 8.76238 4.0863 8.5108C4 8.22663 4 7.91355 4 7.28741V2M10 9V2M17 2V14C15.3431 14 13.5 15.7909 13.5 18C13.5 20.2091 15.3431 22 17 22C18.6569 22 20.5 20.2091 20.5 18C20.5 17.6547 20.455 17.3196 20.3727 17C20.2813 16.6452 20.144 16.3095 19.9714 16"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M7 2V11M7 22V11M7 11L5.42496 9.94997C4.90398 9.60265 4.64349 9.42899 4.45491 9.19955C4.28796 8.99643 4.1627 8.76238 4.0863 8.5108C4 8.22663 4 7.91355 4 7.28741V2M7 11L8.57504 9.94997C9.09602 9.60265 9.35651 9.42899 9.54509 9.19955C9.71204 8.99643 9.8373 8.76238 9.9137 8.5108C10 8.22663 10 7.91355 10 7.28741V2M17 2V14M17 14C15.3431 14 13.5 15.7909 13.5 18C13.5 20.2091 15.3431 22 17 22C18.6569 22 20.5 20.2091 20.5 18C20.5 15.7909 18.6569 14 17 14Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4.00009 1.25C4.4143 1.25 4.75009 1.58579 4.75009 2V7.28741C4.75009 7.96025 4.75773 8.14041 4.80403 8.29286C4.85178 8.4501 4.93007 8.59638 5.03441 8.72333C5.13557 8.84642 5.28124 8.95271 5.84107 9.32594L6.25009 9.59861V2C6.25009 1.58579 6.58588 1.25 7.00009 1.25C7.4143 1.25 7.75009 1.58579 7.75009 2V9.59861L8.1591 9.32594C8.71894 8.95271 8.8646 8.84642 8.96577 8.72333C9.07011 8.59638 9.1484 8.4501 9.19615 8.29286C9.24245 8.14041 9.25009 7.96025 9.25009 7.28741V2C9.25009 1.58579 9.58588 1.25 10.0001 1.25C10.4143 1.25 10.7501 1.58579 10.7501 2V7.28741C10.7501 7.31906 10.7501 7.35031 10.7501 7.38118C10.7505 7.91549 10.7508 8.33556 10.6314 8.72874C10.5264 9.07466 10.3541 9.39648 10.1246 9.67577C9.86368 9.99322 9.51399 10.226 9.06921 10.522C9.04351 10.5391 9.01749 10.5565 8.99116 10.574L7.75009 11.4014V22C7.75009 22.4142 7.4143 22.75 7.00009 22.75C6.58588 22.75 6.25009 22.4142 6.25009 22V11.4014L5.00902 10.574C4.98269 10.5565 4.95667 10.5391 4.93097 10.522C4.48619 10.226 4.1365 9.99322 3.87559 9.67577C3.64604 9.39648 3.47381 9.07466 3.36875 8.72874C3.24935 8.33556 3.24965 7.91548 3.25004 7.38118C3.25007 7.35031 3.25009 7.31906 3.25009 7.28741V2C3.25009 1.58579 3.58588 1.25 4.00009 1.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M17.75 2C17.75 1.58579 17.4142 1.25 17 1.25C16.5858 1.25 16.25 1.58579 16.25 2V13.3392C15.4338 13.5317 14.6696 14.0212 14.0775 14.663C13.2974 15.5084 12.75 16.6851 12.75 18C12.75 19.3149 13.2974 20.4916 14.0775 21.337C14.8483 22.1725 15.9108 22.75 17 22.75C18.0892 22.75 19.1517 22.1725 19.9225 21.337C20.7026 20.4916 21.25 19.3149 21.25 18C21.25 16.6851 20.7026 15.5084 19.9225 14.663C19.3304 14.0212 18.5662 13.5317 17.75 13.3392V2Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
